import React, { FC, useCallback, useEffect, useState } from 'react';

import Fab from '@material-ui/core/Fab';
import MuiTooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import TooltipsTexts, { TSectionKey } from './Utils/TooltipsTexts';
import { TooltipsLoomIds } from './Utils/TooltipsLoomIds';
import { PlayerEditorModalStyled } from '../../scenes/admin/EventWizard/PlayerEditorModal/PlayerEditorModal.Styles';
import { DialogActionsStyled } from '../../scenes/admin/EventWizard/PlayerEditorModal/Components/DialogActions/DialogActions.Styles';
import { IframeContainerStyled } from './Components/IframeContainer.Styles';
import { IFrameStyled } from './Components/IFrame.Styles';

interface ICSSKey {
  tooltipPopper: string;
  fab: string;
  fabLabel: string;
}

interface IProps {
  classes?: Partial<ICSSKey>;
  sectionKey?: TSectionKey;
}

const environment = process.env.REACT_APP_STAGE;

export const Tooltip: FC<IProps> = props => {
  const { classes, sectionKey } = props;

  const videoTutorialId = sectionKey ? TooltipsLoomIds[sectionKey] : undefined;

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [tooltipTitle, setTooltipTitle] = useState('');

  const [hideIcon, setHideIcon] = useState(false);

  useEffect(() => {
    setHideIcon(environment === 'production' && tooltipTitle === '');
  }, [environment, tooltipTitle]);

  useEffect(() => {
    if (sectionKey) {
      setTooltipTitle(
        environment !== 'production' && TooltipsTexts[sectionKey] === ''
          ? sectionKey
          : TooltipsTexts[sectionKey]
      );
    }
  }, [environment, sectionKey]);

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const openModal = useCallback(() => {
    setModalIsOpen(true);
  }, []);

  if (hideIcon) {
    return <div />;
  }

  return (
    <>
      <MuiTooltip
        classes={{
          popper: `tooltip-popper override ${classes ? classes.tooltipPopper || '' : ''}`
        }}
        title={tooltipTitle}
        placement="top"
      >
        <Fab
          classes={{
            label: `tooltip-fab__label override ${classes ? classes.fabLabel || '' : ''}`,
            root: `tooltip-fab override ${classes ? classes.fab || '' : ''}`
          }}
          size="small"
          variant="round"
          onClick={openModal}
        >
          ?
        </Fab>
      </MuiTooltip>

      <PlayerEditorModalStyled
        fullWidth={true}
        maxWidth="lg"
        onClose={closeModal}
        aria-labelledby="customized-dialog-title"
        open={modalIsOpen}
      >
        <DialogActionsStyled>
          <div className="dialog-actions">
            <IconButton className="close-button" onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogActionsStyled>

        <IframeContainerStyled>
          <IFrameStyled
            title="Wagl tutorial"
            src={`https://www.loom.com/embed/${videoTutorialId}`}
            frameBorder="0"
            allowFullScreen={true}
          />
        </IframeContainerStyled>
      </PlayerEditorModalStyled>
    </>
  );
};
